import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Routes, STANDARD_ROUTING_CONFIG } from 'src/api/routing.api';
import { map } from 'rxjs/operators';
import { UserV2Service } from '@schenck/rotec-components';

@Injectable()
export class RoutingGuardService {
  private readonly userService = inject(UserV2Service);

  get routingConfig$(): Observable<Routes> {
    return this.userService.currentUser$.pipe(
      map((currentUser) => {
        const config = currentUser ? currentUser.machinecenter : STANDARD_ROUTING_CONFIG;
        return {
          statistics: config.statistics,
          production: config.production,
          quality: config.quality,
          operators: config.operators,
          notifications: config.notifications,
          condition: config.condition,
        };
      })
    );
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    const screenName = state.url.replace('/', '');
    return this.routingConfig$.pipe(
      map((routingConfig) => {
        return routingConfig[screenName];
      })
    );
  }
}
